// John Eldhose 20180618
import { RestfulPost } from './Restful';

export async function updateAddress(data, orgi) {
  data['original'] = orgi;
  const addr = await RestfulPost('updateAddress', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return addr;
}



// WEBPACK FOOTER //
// ./src/Api/updateAddress.js